/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Bio_Intro_PrefixInputs */

const en_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A full-stack developer with a `)
};

const ar_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطوّر Web متكامل حاصل على `)
};

const bn_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একজন ফুল-স্ট্যাক ডেভেলপার, যার `)
};

const de_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Full-Stack-Entwickler mit einem`)
};

const es_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un desarrollador full-stack con`)
};

const fr_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un développeur full-stack avec un`)
};

const pt_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um desenvolvedor full-stack com um`)
};

const zh_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全栈开发人员`)
};

const tr_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam kapsamlı bir geliştirici`)
};

const ru_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-stack разработчик с`)
};

const pl_about_bio_intro_prefix = /** @type {(inputs: About_Bio_Intro_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programista full-stack z`)
};

/**
* | output |
* | --- |
* | "A full-stack developer with a" |
*
* @param {About_Bio_Intro_PrefixInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_bio_intro_prefix = /** @type {((inputs?: About_Bio_Intro_PrefixInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Bio_Intro_PrefixInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_bio_intro_prefix(inputs)
	if (locale === "bn") return bn_about_bio_intro_prefix(inputs)
	if (locale === "de") return de_about_bio_intro_prefix(inputs)
	if (locale === "es") return es_about_bio_intro_prefix(inputs)
	if (locale === "fr") return fr_about_bio_intro_prefix(inputs)
	if (locale === "pt") return pt_about_bio_intro_prefix(inputs)
	if (locale === "zh") return zh_about_bio_intro_prefix(inputs)
	if (locale === "tr") return tr_about_bio_intro_prefix(inputs)
	if (locale === "ru") return ru_about_bio_intro_prefix(inputs)
	if (locale === "pl") return pl_about_bio_intro_prefix(inputs)
	return en_about_bio_intro_prefix(inputs)
});